export const addTypeAndParentSlugToTopics = (obj, parentSlug) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      obj[key].type = 'topic';
      obj[key].parentSlug = parentSlug;
    }
  }
};

export const filterAssemblyCategory = categories => {
  return categories.filter(category => category.original_id != 272) || [];
};

export const mergeTopics = (topic, topics) => {
  if (!topic && !topics) {
    return [];
  }

  if (!Array.isArray(topics)) return [topic, topics];

  const mergedTopics = [topic, ...topics];
  return mergedTopics;
};
